

module.exports = {
    Hm3: 1,
    Omaha: 2,
    HmApps: 3,
};



// WEBPACK FOOTER //
// ./src/state/headerType.js